export default __webpack_public_path__ + "static/media/page.71ca2bc8.jpg";